import GuestProfileForm from "../guest-profile-form/guest-profile-form";
import { useApi, useMount } from "hooks";
import React, { useCallback, useContext } from "react";
import lang from "translations";
import { createGuestProfile } from "apis/guest-profile.api";
import { guestProfileRequest } from "mappers";
import { mixpanel, TrackEvent } from "mixpanel";
import { VenueContext } from "contexts";
import { updateEatAppRoomsMapping } from "apis/eat-app.api";

const CreateGuestProfile = () => {
  const { siigoConnected } = useContext(VenueContext);

  const { request, loading: submitting } = useApi({
    api: createGuestProfile,
    handleOwnError: {
      badrequest: true,
    },
    paramsMapper: guestProfileRequest,
  });

  const { request: updateRoomsMapping, loading: mapping } = useApi({
    api: updateEatAppRoomsMapping,
    handleOwnError: true,
  });

  useMount(() => {
    mixpanel.track(TrackEvent.VisitedPage, {
      Page: lang.createNewGuestProfile,
    });
  });

  const submitForm = useCallback(
    async (params) => {
      try {
        params.isTagRegistration = true;
        const res = await request(params);

        if (params.eatAppRoomId) {
          const internalGuestProfileId =
            res?.data?.guestProfileId ||
            res?.data?.id ||
            res?.data?.data?.guestProfileId ||
            res?.data?.data?.id;

          if (!internalGuestProfileId) {
            throw new Error("Created guest profile response did not include a guest profile ID.");
          }

          await updateRoomsMapping({
            venueId: params.venueId,
            roomsMapping: [
              {
                eatAppId: params.eatAppRoomId,
                internalGuestProfileId,
              },
            ],
          });
        }

        return {
          response: res,
          message: lang.populate(lang.guestProfileNameCreate, [params.name]),
        };
      } catch (e) {
        throw e;
      }
    },
    [request, updateRoomsMapping]
  );

  return (
    <GuestProfileForm
      title={lang.createNewGuestProfile}
      submit={submitForm}
      submitting={submitting || mapping}
      initialState={{ isAskQuestion: siigoConnected }}
      isCreate
    />
  );
};

export default CreateGuestProfile;
